// ============================================================
//  FOTO-UPLOAD-HELPER — für alle CMS-Formulare
//  Lädt eine Datei nach Storage hoch und gibt die Download-URL
//  zurück. Die Cloud Function "resizePhoto" komprimiert danach
//  automatisch im Hintergrund (Trigger auf denselben Pfad).
// ============================================================
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "../firebase";

/**
 * @param {File} file
 * @param {"matchberichte"|"cms"} ordner
 * @returns {Promise<string>} Download-URL
 */
export async function fotoHochladen(file, ordner = "cms") {
  if (!file.type.startsWith("image/")) {
    throw new Error("Nur Bilddateien sind erlaubt.");
  }
  if (file.size > 15 * 1024 * 1024) {
    throw new Error("Datei ist grösser als 15 MB.");
  }
  const dateiname = `${Date.now()}-${file.name.replace(/[^a-zA-Z0-9._-]/g, "_")}`;
  const storageRef = ref(storage, `${ordner}/${dateiname}`);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
}

/** Foto per Download-URL wieder löschen (z.B. beim Entfernen aus einem Formular) */
export async function fotoLoeschen(downloadUrl) {
  try {
    const storageRef = ref(storage, downloadUrl);
    await deleteObject(storageRef);
  } catch (err) {
    console.warn("Foto konnte nicht gelöscht werden:", err.message);
  }
}
